<!--The content below is only a placeholder and can be replaced.-->
<router-outlet></router-outlet>

<!-- loading indicator -->
<app-loading *ngIf="loading$ | async"></app-loading>
